/**
 * Audit findings vocabulary — audit_vocabulary/{hospitalId}/entries/{entryId}
 * Security rules: see firestore.rules (PASUL 0)
 */

import {
  collection,
  doc,
  getDocs,
  query,
  where,
  orderBy,
  addDoc,
  updateDoc,
  deleteDoc,
  increment,
  Timestamp,
  limit
} from 'firebase/firestore';
import { db } from '../firebase';

function entriesCol(hospitalId) {
  return collection(db, 'audit_vocabulary', hospitalId, 'entries');
}

const CATEGORIES = ['observatii', 'puncte_forte', 'imbunatatire', 'oportunitati', 'riscuri'];

function normalizeText(text) {
  return (text || '').trim();
}

export const auditVocabularyService = {
  async getSuggestions(hospitalId, category, searchTerm) {
    if (!hospitalId || !CATEGORIES.includes(category)) return [];
    const term = normalizeText(searchTerm).toLowerCase();
    const q = query(
      entriesCol(hospitalId),
      where('category', '==', category),
      orderBy('usageCount', 'desc'),
      limit(40)
    );
    const snap = await getDocs(q);
    const rows = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    const filtered = term
      ? rows.filter((r) => (r.text || '').toLowerCase().startsWith(term))
      : rows;
    return filtered.slice(0, 10).map((r) => r.text);
  },

  async upsertEntry(hospitalId, category, text) {
    const t = normalizeText(text);
    if (!hospitalId || !t || !CATEGORIES.includes(category)) return;
    const q = query(entriesCol(hospitalId), where('category', '==', category));
    const snap = await getDocs(q);
    const existing = snap.docs.find(
      (d) => (d.data().text || '').trim().toLowerCase() === t.toLowerCase()
    );
    const now = Timestamp.now();
    if (existing) {
      await updateDoc(existing.ref, {
        usageCount: increment(1),
        lastUsedAt: now
      });
    } else {
      await addDoc(entriesCol(hospitalId), {
        text: t,
        category,
        usageCount: 1,
        lastUsedAt: now,
        createdAt: now
      });
    }
  },

  async deleteEntry(hospitalId, entryId) {
    const ref = doc(db, 'audit_vocabulary', hospitalId, 'entries', entryId);
    await deleteDoc(ref);
  },

  async listAll(hospitalId) {
    if (!hospitalId) return [];
    const snap = await getDocs(entriesCol(hospitalId));
    const rows = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    rows.sort((a, b) => {
      const c = String(a.category || '').localeCompare(String(b.category || ''));
      if (c !== 0) return c;
      return (b.usageCount || 0) - (a.usageCount || 0);
    });
    return rows;
  }
};
